import { Form, Select } from "antd";
import * as React from "react";
import { ZodEnum } from "zod";

import { FieldDef, itemName, makeLabel } from "../attrMetaEditorUtils";

type PropsEnumEd = {
  node: ZodEnum;
  path: string[];
  field?: FieldDef;
};

export const EnumEd: React.FC<PropsEnumEd> = (props) => {
  const { node, path, field } = props;
  const options = Object.entries(node.def.entries).map(([value, label]) => ({
    value,
    label,
  }));
  return (
    <Form.Item name={itemName(path)} label={makeLabel(node, path, field)}>
      <Select options={options} allowClear title={path.join(".")} />
    </Form.Item>
  );
};
